module.exports = __webpack_public_path__ + "static/media/cart.e097a563.jpg";